import MxTypography from "@rf-l1/MxTypography";
import React from "react";

interface MxEmptyBodyProps {
  children?: React.ReactNode;
}
const MxEmptyBody = (props: MxEmptyBodyProps) => {
  const { children } = props;
  return (
    <MxTypography
      variant="caption"
      fontWeight={400}
      color={"grey"}
      textAlign={"center"}
    >
      {children}
    </MxTypography>
  );
};

export default MxEmptyBody;
